export default __webpack_public_path__ + "static/media/medium.2b1f7c67.svg";